// extracted by mini-css-extract-plugin
export default {"varInfo":"VarItem_varInfo__FzTMI","varNumber":"VarItem_varNumber__vzpy6","varTitle":"VarItem_varTitle__2CZsD"};